module.exports = __webpack_public_path__ + "img/snb_gjng.a8a8ae1f.svg";